/**
 * Captures the L'addition session token from the URL fragment and strips it, as the very first
 * module `index.tsx` evaluates: Sentry records the URL as soon as it is initialised, so the
 * token must be gone before then. It imports nothing, so nothing can run ahead of it.
 */

// Kept local rather than read from `routesUrl`: importing the route config here would evaluate it first.
const WEBVIEW_PATH_PREFIX = '/pos/posadd/loyalty/';
const SESSION_FRAGMENT_KEY = 's';
const SESSION_IN_FRAGMENT = /(#(?:[^#\s]*&)?s=)[^&#\s]+/g;
const REDACTED = '[Filtered]';

const captureSessionFromFragment = (): string | null => {
  if (!window.location.pathname.startsWith(WEBVIEW_PATH_PREFIX)) {
    return null;
  }
  const token = new URLSearchParams(window.location.hash.replace(/^#/, '')).get(SESSION_FRAGMENT_KEY);
  if (token) {
    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
  }
  return token;
};

let capturedToken: string | null = captureSessionFromFragment();

/** Hands the token over once: after the first call, this module no longer holds it. */
export const takeWebviewSessionToken = (): string | null => {
  const token = capturedToken;
  capturedToken = null;
  return token;
};

export const redactWebviewSession = (text: string): string => text.replace(SESSION_IN_FRAGMENT, `$1${REDACTED}`);
